import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ReportSubCategory } from '../../entities/report-sub-category';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ReportSubCategoryService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly reportSubCategoryBaseUrl:string = `${Settings.apiUrl}/v1/ReportSubCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getReportSubCategories(): Promise<ReportSubCategory[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(ReportSubCategoryService.reportSubCategoryBaseUrl);

    oDataBuilder
      .expand("ReportCategory")
      .orderBy("Name");

    let reportSubCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(reportSubCategoryUrl)
      .toPromise()
      .then(response => response.json().value);

  }

  createReportSubCategory(reportSubCategory: ReportSubCategory): Promise<ReportSubCategory> {
    let reportSubCategoryUrl: string = `${Settings.apiUrl}/v1/ReportSubCategories`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete reportSubCategory.ReportSubCategoryId;

    return this.http.post(reportSubCategoryUrl, JSON.stringify(reportSubCategory), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchReportSubCategory(reportSubCategory: ReportSubCategory): Promise<null> {

    let reportSubCategoryUrl: string = `${Settings.apiUrl}/v1/ReportSubCategories(${reportSubCategory.ReportSubCategoryId})`;

    return this.http.patch(reportSubCategoryUrl, JSON.stringify(reportSubCategory), this.options)
      .toPromise()
      .then(response => response);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/report-sub-category.service.ts